import { MessagesSquare } from "lucide-react"
import { cn } from "@/lib/utils"

const sizes = {
  lg: { box: "size-10", icon: "size-[21px]", text: "text-[21px]" },
  md: { box: "size-9", icon: "size-[19px]", text: "text-[20px]" },
  sm: { box: "size-7", icon: "size-4", text: "text-base" },
}

export function BrandLogo({ size = "lg", className }: { size?: keyof typeof sizes; className?: string }) {
  const s = sizes[size]
  return (
    <div className={cn("group flex items-center gap-3 select-none", className)}>
      <span className={cn("flex items-center justify-center rounded-xl bg-primary text-primary-foreground transition-transform duration-300 group-hover:-rotate-6", s.box)}><MessagesSquare className={s.icon} /></span>
      <span className={cn("font-display font-bold tracking-[-.04em] text-foreground", s.text)}>BubbleDesk</span>
    </div>
  )
}
